import { render, staticRenderFns } from "./event_details.vue?vue&type=template&id=71aa3cb5&scoped=true&"
import script from "./event_details.vue?vue&type=script&lang=js&"
export * from "./event_details.vue?vue&type=script&lang=js&"
import style0 from "./event_details.vue?vue&type=style&index=0&id=71aa3cb5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71aa3cb5",
  null
  
)

export default component.exports